export default "__VITE_ASSET__ccd42b0a__"